import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import { FIREBASE_TOKEN_KEY } from '@/lib/constants';
import { ROUTES } from '@/lib/routes';
import { RoleType } from '@addmile/backend-client';

import { useCoachData } from './useCoachData';
import { useSignIn } from './useSignIn';

const initialValues = {
  email: '',
  password: '',
};

const validationSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required (email)'),
  password: Yup.string().required('Required (min 8 characters)'),
});

export const useSignInForm = () => {
  const navigate = useNavigate();
  const signInMutation = useSignIn();
  const coachDataMutation = useCoachData();

  useEffect(() => {
    const firebaseToken = localStorage.getItem(FIREBASE_TOKEN_KEY);
    if (firebaseToken) {
      navigate(ROUTES.ADMIN_USERS);
    }
  }, [navigate]);

  const handleSubmit = async (values: { email: string; password: string }) => {
    const { email, password } = values;

    const { role } = await signInMutation.mutateAsync({ email, password });

    if (role === RoleType.Coach) {
      await coachDataMutation.mutateAsync(email);
    }
  };

  return {
    initialValues,
    validationSchema,
    handleSubmit,
    isSubmitting: signInMutation.isPending || coachDataMutation.isPending,
  };
};
